import React from 'react';

export const PolicyViolations = () => {
  return <div>Policy Violations</div>;
};
